/**
 * Import blocks
 */
import './wp-events';